import { MessageData } from 'store/app/types';
import { setCurrentJournalsPage } from '../actions';
import { getReportDataPage, ReportPageResponse } from '../api';
import { JournalType } from '../models/vatReportData';
import { FetchDataPageAction } from '../types';
import { call, put } from 'redux-saga/effects';
import { renderErrorMessage } from 'utils/render-error-message';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';

export function* fetchDataJournalsPageSaga(action: FetchDataPageAction) {
  const { reportId, page, pageSize, transactionType, groupingType, filters } =
    action.payload;

  try {
    const convertedFilters = convertFiltersToMap(filters);
    const response: ReportPageResponse = yield call(
      getReportDataPage,
      reportId,
      page,
      pageSize,
      transactionType,
      groupingType,
      convertedFilters
    );

    if (response.data) {
      if (response.data.journals) {
        const journals = response.data.journals;
        let total = 0;
        if (transactionType === JournalType.TRANSACTION) {
          total = response.data.transactionsSize;
        } else if (transactionType === JournalType.EXCEPTION) {
          total = response.data.exceptionsSize;
        }
        yield put(setCurrentJournalsPage(journals, transactionType, total));
      }
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
  }
}

const convertFiltersToMap = (filters) => {
  const resultMap = {};
  for (const key in filters) {
    if (Object.hasOwnProperty.call(filters, key)) {
      const filterObject = filters[key];

      if (filterObject && Array.isArray(filterObject.value)) {
        resultMap[key] = filterObject.value;
      }
    }
  }

  return resultMap;
};
